import { Box, BoxProps, Flex, HStack, Text, Tooltip } from "@chakra-ui/react";
import { FunctionComponent, ReactElement } from "react";
import { MdInfoOutline } from "react-icons/md";
import { isEmpty } from "lodash";

interface DetailRowProps {
	label: string;
	labelWidth?: number | string;
	hidden?: boolean;
	children: JSX.Element | JSX.Element[];
	tooltip?: string;
}

/**
 * Detail row that has a label and value
 */
const DetailRow: FunctionComponent<DetailRowProps & BoxProps> = (props: DetailRowProps & BoxProps): ReactElement => {
	const { label, labelWidth, hidden, children, tooltip = "", ...boxProps } = props;

	return hidden ? (
		<></>
	) : (
		<HStack minH={8} alignItems="center">
			<Tooltip hasArrow hidden={isEmpty(tooltip)} label={tooltip}>
				<Text width={labelWidth ?? 200} fontWeight={"500"}>
					<Flex align={"center"}>
						{label}&nbsp;{" "}
						{!isEmpty(tooltip) && (
							<MdInfoOutline style={{ display: "inline-block", fontSize: "16px", verticalAlign: "bottom" }} />
						)}
					</Flex>
				</Text>
			</Tooltip>

			<Box flex={1} {...boxProps}>
				{children}
			</Box>
		</HStack>
	);
};

export default DetailRow;
